import { Avatar, Flex, Stack } from '@mantine/core'
import React, { useMemo } from 'react'
import CustomeFieldItem from 'src/components/CustomComponents/CustomFieldItem'
import { userDataFields } from 'src/variable/constant'
import styles from '../UserDetail/UserDetail.module.scss'
import CustomGoBack from 'src/components/CustomComponents/CustomGoBack'
import { useNavigate } from 'react-router-dom'
const formatFieldValue = (value) => {
	if (value === null || value === undefined || value === '') return '-'
	if (Array.isArray(value)) {
		const items = value
			.map((item) => (typeof item === 'string' ? item : item?.name || ''))
			.filter(Boolean)
		return items.length ? items.join(', ') : '-'
	}
	if (typeof value === 'boolean') return value ? 'Active' : 'Inactive'
	if (typeof value === 'object') return value?.name || '-'
	return value
}

function MyProfile({
	fields = userDataFields,
	label = 'Users',
	goBack = '/users',
}) {
	const data = useMemo(() => {
		try {
			return JSON.parse(localStorage.getItem('info') || '{}')
		} catch (error) {
			console.log('MyProfile parse localStorage info error:', error)
			return {}
		}
	}, [])
	const navigate = useNavigate()
	return (
		<Stack sx={{ width: '100%' }}>
			<CustomGoBack
				label={label}
				onClick={() => {
					navigate(goBack)
				}}
			/>
			<Flex className={styles.containerFields}>
				<Avatar src={data?.avatar} size={160} radius={'50%'} />
				<Flex sx={{ flexWrap: 'wrap' }}>
					<Flex sx={{ flexWrap: 'wrap' }}>
						{fields.map((field) => (
							<CustomeFieldItem
								field={field}
								value={formatFieldValue(data?.[field.value])}
								key={field.value}
							/>
						))}
					</Flex>
				</Flex>
			</Flex>
		</Stack>
	)
}

export default React.memo(MyProfile)
